export const CHANGE_CONTROL_STATUS_APPROVED = 'approved'
export const CHANGE_CONTROL_STATUS_ACCEPTED = 'accepted'
export const CHANGE_CONTROL_STATUS_DRAFT = 'draft'
export const CHANGE_CONTROL_STATUS_REJECTED = 'rejected'
export const CHANGE_CONTROL_STATUS_SUBMITTED = 'submitted'
export const CHANGE_CONTROL_STATUS_WITHDRAWN = 'withdrawn'
